// A slot in the pager: a page number or a "…" gap
export type PageItem = number | "start-ellipsis" | "end-ellipsis";

const range = (from: number, to: number): number[] =>
    Array.from({ length: Math.max(to - from + 1, 0) }, (_, i) => from + i);

// Decides what to render, always keeping the first and last page visible:
//   1 2 3 4 5 … 20   |   1 … 8 9 10 … 20   |   1 … 16 17 18 19 20
// The item count stays constant while you move, so the pager never jumps around.
export const getPageItems = (
    page: number,
    totalPages: number,
    siblingCount = 1 // Pages shown on each side of the current one
): PageItem[] => {
    // Few pages: show them all
    if (totalPages <= siblingCount * 2 + 5) return range(1, totalPages);

    const siblingsStart = Math.max(
        Math.min(page - siblingCount, totalPages - 2 - siblingCount * 2),
        3
    );
    const siblingsEnd = Math.min(
        Math.max(page + siblingCount, 3 + siblingCount * 2),
        totalPages - 2
    );

    return [
        1,
        // A gap, or page 2 when the gap would hide only a single page
        siblingsStart > 3 ? "start-ellipsis" : 2,
        ...range(siblingsStart, siblingsEnd),
        siblingsEnd < totalPages - 2 ? "end-ellipsis" : totalPages - 1,
        totalPages
    ];
};